export default class ApiError extends Error{
  constructor(message: string){
    super();
    this.message = message;
    this.stack = (new Error()).stack;
    this.name = this.constructor.name;
  }
}